/**
 * TicketStatusBadge - Status indicator for tickets
 */

import { cn } from '@/lib/utils';
import { semanticTokens } from '@packages/config/theme';
import type { TicketPriority, TicketStatus } from '../types';
import { TICKET_PRIORITY_CONFIG, TICKET_STATUS_CONFIG } from '../types';

interface TicketStatusBadgeProps {
  status: TicketStatus;
  className?: string;
}

export function TicketStatusBadge({ status, className }: TicketStatusBadgeProps) {
  const config = TICKET_STATUS_CONFIG[status];

  const colorClasses = {
    default: 'bg-muted text-muted-foreground',
    primary: 'bg-primary/10 text-primary',
    success: cn(semanticTokens.positive.bg, semanticTokens.positive.fg),
    warning: cn(semanticTokens.warning.bg, semanticTokens.warning.fg),
    danger: cn(semanticTokens.danger.bg, semanticTokens.danger.fg),
  };

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        colorClasses[config.color],
        className
      )}
    >
      {config.label}
    </span>
  );
}

interface TicketPriorityBadgeProps {
  priority: TicketPriority;
  className?: string;
}

export function TicketPriorityBadge({ priority, className }: TicketPriorityBadgeProps) {
  const config = TICKET_PRIORITY_CONFIG[priority];

  const colorClasses = {
    default: 'bg-muted text-muted-foreground',
    primary: 'bg-primary/10 text-primary',
    warning: cn(semanticTokens.warning.bg, semanticTokens.warning.fg),
    danger: cn(semanticTokens.danger.bg, semanticTokens.danger.fg),
  };

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        colorClasses[config.color],
        className
      )}
    >
      {config.label}
    </span>
  );
}
